var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChartBarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8335 9.9092C10.8335 9.57161 10.9433 9.24783 11.1386 9.00924C11.334 8.77053 11.599 8.63647 11.8752 8.63647H13.9585C14.2348 8.63647 14.4998 8.77053 14.6951 9.00924C14.8904 9.24783 15.0002 9.57161 15.0002 9.9092V13.7274C15.0002 14.0648 14.8904 14.3886 14.6951 14.6273C14.4998 14.8659 14.2348 15.0001 13.9585 15.0001H11.8752C11.599 15.0001 11.334 14.8659 11.1386 14.6273C10.9433 14.3886 10.8335 14.0648 10.8335 13.7274V9.9092Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 8.63631C1 8.21433 1.10981 7.80961 1.30509 7.51137C1.50046 7.21299 1.76546 7.04541 2.04167 7.04541H4.125C4.4013 7.04541 4.6663 7.21299 4.86157 7.51137C5.05694 7.80961 5.16667 8.21433 5.16667 8.63631V13.409C5.16667 13.8309 5.05694 14.2356 4.86157 14.534C4.6663 14.8322 4.4013 14.9999 4.125 14.9999H2.04167C1.76546 14.9999 1.50046 14.8322 1.30509 14.534C1.10981 14.2356 1 13.8309 1 13.409V8.63631Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1.99929C6 1.73426 6.10975 1.48009 6.3051 1.29269C6.50045 1.10528 6.7654 1 7.04167 1H9.125C9.40125 1 9.66625 1.10528 9.86158 1.29269C10.0569 1.48009 10.1667 1.73426 10.1667 1.99929V13.9907C10.1667 14.2557 10.0569 14.5099 9.86158 14.6973C9.66625 14.8847 9.40125 14.99 9.125 14.99H7.04167C6.7654 14.99 6.50045 14.8847 6.3051 14.6973C6.10975 14.5099 6 14.2557 6 13.9907V1.99929Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartBarIcon);
export default __webpack_public_path__ + "static/media/chart_bar_icon.c95bb4e5a942c5baa7dd8bcc5ec75051.svg";
export { ForwardRef as ReactComponent };